import { clsx } from "clsx";

import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getConditionalFiltersCount,
    getConditionalNodeBody,
    getConditionalNodeTitle,
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
    isConditionalNodeConfigured,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { NodeType } from "Types/Journey";

import styles from "./ConditionalBlock.module.scss";

// TODO: update type to import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";
// and follow up updateContactBlock or the IVR blocks work

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.Conditional).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.Conditional);

export function ConditionalBlock({ data }: { data?: any }): JSX.Element {
    const filtersCount = getConditionalFiltersCount(data);
    const isActive = isConditionalNodeConfigured(data);

    return (
        <BlockContainer variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle nodeData={data} fallBackDisplay={getConditionalNodeTitle(data)}></BlockTitle>
            <BlockContent
                isActive={isActive}
                className={clsx({
                    [styles.empty]: !isActive,
                })}
            >
                {getConditionalNodeBody(data)}
            </BlockContent>
            {filtersCount ? (
                <div
                    className={clsx([styles.filters], {
                        [styles.branchNode]: isActive,
                        [styles.blockText]: isActive,
                    })}
                >
                    <span>{`Filters (${filtersCount})`}</span>
                </div>
            ) : (
                <></>
            )}
        </BlockContainer>
    );
}
